import React from 'react';
import {HashLink as Link} from "react-router-hash-link";

const InitialBRBizTourReports = {
    url: `/board/BreachRisk/Business/Report/Overview`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        verified_ownership: true,
        // subscription: "Business",
        // subLevel: ["pro", "premium"],
        hasScores: true,
    },
    openingModal: {
        icon: null,
        heading: "Tour BreachRisk™ Report?",
        description: <div className={"text-center"}>
            <p>
                BreachRisk&trade; Reports provides the first break down of the Score into the individual threats discovered.
                Find information about individual threats on a high level, the report is meant to be understood regardless of technical knowledge.
            </p>
    </div>
},
    tourSteps: {
        1:{
            step: 1,
            title: "Detailed BreachRisk™ Scores History",
            content: <>
                <p>Track BreachRisk™ Scores and fidelity over time.</p>
                <p>
                    Your score changes as hackers get better or your defenses change. Your BreachRisk&trade; Score is a 60 - 90 day rolling average of the most dangerous Notable Threats.
                </p>
                <p>
                    The red and green lines represent fidelity, the best and worst case scenario from the hacker's perspective. Learn more about Fidelity by visiting our <Link smooth to={`/board/userguide`}className={"text-white"}><u>our Interactive User's Guide</u></Link>.
                </p>
                {/*<p>Fidelity is how</p>*/}
            </>,
            anchorEl: "#tourStepBRHistory",
            last: false,
        },
        2: {
            step: 2,
            title: "Risk Chart: Notable Threats",
            placement: "right",
            scrollToElement: "#tourStepIdentifyYourThreats",
            content: <>
                <p>
                    The risk chart plots individual threats in terms of likelihood and impact. These
                    threats are not theoretical, a malicious hacker could attempt to exploit them now.
                </p>
                <p>
                    To improve BreachRisk&trade; Score, eliminate or mitigate each of these threats.
                </p>
                <p>
                    <em>
                        Hover over the chart to see more information about each risk.
                    </em>
                </p>
            </>,
            anchorEl: "#tourStepSummaryScatterChart",
            element: document.getElementsByClassName("tourSummaryScatterChartCol"),
            last: false,
        },
        3: {
            step: 3,
            title: "Summary Of All Threats",
            placement: "left",
            content: <>
                <p>
                    Individual threats are summarized at a high level in this table, so you can see the type of threat, it's relative risk, and it's pen testing status (if applicable).
                </p>
            </>,
            anchorEl: "#tourThreartsSummaryTable",
            scrollToElement: "#tourBRScoreDial",
            element: document.getElementsByClassName("tourThreatsSummaryCol"),
            last: false,
        },
        4: {
            step: 4,
            title: "Factors Influencing Your BreachRisk™ Score",
            content: "These positive and aggravating factors provide general context that is helpful in understanding the overall risk environment.",
            anchorEl: "#tourReportFindingsSummary",
            placement: "top-center",
            element: null,
            last: false,
        },
        5: {
            step: 5,
            title: "Full Context with BreachRisk™ Technical",
            content: "BreachRisk™ Technical provides details to help your team eliminate, mitigate, and track threats.  ",
            anchorEl: "#tourStepBRBusinessReportTechData",
            element: document.getElementsByClassName("tourStepBRBusinessReportTechData"),
            last: true,
        },
        // 4: {
        //     step: 4,
        //     title: "Visit Your Report Page To Go Deeper",
        //     content: "You'll find more details about what we've found by visiting your report page.",
        //     anchorEl: "#tourStepBRBusinessReportOverview",
        //     last: false,
        // },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}

export default InitialBRBizTourReports;